/* Honour Wellness — sticky Add to Cart bar, mobile product pages only.

   The bar is visible for the whole page, so there is no scroll handling here.
   Showing and hiding is done entirely by CSS media query. Earlier versions
   revealed the bar only after scrolling past the real button, using first an
   IntersectionObserver and then a scroll listener; both were dropped when the
   brief changed to "always visible", which removed the problem rather than
   working around it.

   This script does two things only:
     1. forwards a tap to the page's real Add to Cart, so the Appstle
        subscription choice, quantity and variant all carry over — a duplicate
        button holding its own logic would drift out of step with the app;
     2. keeps the label and the disabled state in step with that real button,
        which changes on variant switches and when something sells out. */
(function () {
  var SELECTOR = '.product-details__add-to-cart-button';

  function init() {
    if (!document.body.classList.contains('template-product')) return;
    if (document.querySelector('.hw-sticky-atc')) return;

    var real = document.querySelector(SELECTOR);
    if (!real) return;

    var bar = document.createElement('div');
    bar.className = 'hw-sticky-atc';

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'hw-sticky-atc__button';
    button.textContent = (real.textContent || 'Add to cart').trim();
    bar.appendChild(button);
    document.body.appendChild(bar);

    // Re-queried each time rather than held in a variable: the subscription
    // app re-renders this area, and a stored reference can end up pointing at
    // a button that is no longer in the page.
    function realButton() {
      return document.querySelector(SELECTOR);
    }

    function sync() {
      var current = realButton();
      if (!current) return;

      var label = (current.textContent || '').trim();
      if (label && button.textContent !== label) button.textContent = label;
      button.disabled = current.disabled || current.hasAttribute('disabled');
    }

    button.addEventListener('click', function () {
      var current = realButton();
      if (current) current.click();
    });

    // Watch the surrounding details column rather than the button itself, so a
    // re-render that replaces the button is still picked up.
    var scope = real.closest('.product-details') || real.parentElement || document.body;
    new MutationObserver(sync).observe(scope, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'class']
    });

    // Variant and purchase-option changes fire change events in this column.
    scope.addEventListener('change', sync);

    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
